import Component from "../../lib/component";
import Mark from "mark.js";

export const InventoryItemConfig = {
    componentTypeKey: 'InventoryItem',
    baseHtmlClass: 'inventory__item',
    selector: '.inventory__item',

    datasetConfigKey: 'inventory__item__config',
    filterContentDatasetConfigKey: 'filter_content',

    visibleHtmlClassModifier: 'visible',
    invisibleHtmlClassModifier: 'invisible',
};

export class InventoryItem extends Component {

    constructor(id_or_element) {
        super({
            element: id_or_element,
            config: InventoryItemConfig
        });

        this.element.classList.add(InventoryItemConfig.baseHtmlClass); // In case the class wasn't already statically set.

        this.setDatasetConfig(InventoryItemConfig.datasetConfigKey);
        this.filterContent = this.getFilterContentConfig();

        this.markInstance = new Mark(this.element);

        this.isVisible = true;

        this.render();
    }

    render() {
        this.swapHtmlClassStates(this.isVisible, InventoryItemConfig.visibleHtmlClassModifier, InventoryItemConfig.invisibleHtmlClassModifier);
    }

    getFilterContent() {
        return this.filterContent || this.element.innerText;
    }

    applyFilter(searchStr) {
        const regex = new RegExp(searchStr, "i");
        const willFilter = regex.test(this.getFilterContent());
        this.isVisible = !!willFilter;
        performMark(this.markInstance, searchStr);
    }

    getFilterContentConfig() {
        const configValue = this.getDatasetConfigValue(InventoryItemConfig.filterContentDatasetConfigKey);
        return ((typeof configValue !== 'undefined') ? configValue : this.element.innerText);
    }

}


function performMark(markInstance, searchStr) {
    let options = {className: 'highliter'};
    // Remove previous marked elements and mark
    // the new keyword inside the context
    markInstance.unmark({
        done: function () {
            markInstance.mark(searchStr, options);
        }
    });
};